import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Icon } from 'antd';

import { ModalSto } from 'components/sto';

function AccountNumberInfoModal(props) {
    const { formatMessage } = useIntl();
    const url = (
        <a href={formatMessage({ id: 'popup.accountnumber.link' })} rel="noopener noreferrer" target="_blank">
            <FormattedMessage id="popup.accountnumber.link" />
        </a>
    );

    return (
        <ModalSto okText="general.ok" onOk={props.onOk} visible={props.visible}>
            <React.Fragment>
                <div className="tooltip">
                    <Icon type="question-circle" />
                    <div className="tooltip-details">
                        <h2 className="pop-up-title">
                            <FormattedMessage id="popup.accountnumber.title" />
                        </h2>
                        <p>
                            <FormattedMessage id="popup.accountnumber.body.1" />
                        </p>
                        <p>
                            <FormattedMessage id="popup.accountnumber.body.2" values={{ url }} />
                        </p>
                    </div>
                </div>
            </React.Fragment>
        </ModalSto>
    );
}

export default AccountNumberInfoModal;
